import { combineReducers } from 'redux'
import * as clientManagementState from './clientManagement'
import * as dashboardState from './dashboard'
import * as moduleManagementState from './moduleManagement'
import * as refreshAccessTokenState from './refreshAccessToken'
import * as uploadImageState from './uploadImage'
import * as userAuthenticationState from './userAuthentication'
import * as userManagementState from './userManagement'
import * as entityManagementState from "./entityManagemnt"

export {
  clientManagementState,
  dashboardState,
  moduleManagementState,
  refreshAccessTokenState,
  uploadImageState,
  userAuthenticationState,
  userManagementState,
  entityManagementState
}

export default combineReducers({
  dashboard: dashboardState.default(),
  userAuthentication: userAuthenticationState.default(),
  refreshAccessToken: refreshAccessTokenState.default(),
  clientManagement: clientManagementState.default(),
  moduleManagement: moduleManagementState.default(),
  userManagement: userManagementState.default(),
  uploadImage: uploadImageState.default(),
  entityManagement : entityManagementState.default()
})
